import { MenuOutlined }        from '@ant-design/icons';
import React                   from 'react';
import { Dropdown }            from 'antd';
import { Button }              from 'antd';
import { DownOutlined }        from '@ant-design/icons';
import FormattedMessageWrapper from './FormattedMessageWrapper';
import type { MenuProps }      from 'antd';

export const MODE_ICON = 'icon';

interface CustomMenuItem {
  danger?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  icon?: React.ReactNode;
  key: string;
  label: React.ReactNode;
  onClick: () => void;
  position?: number;
}

interface DropDownMenuProps {
  items: CustomMenuItem[];
  mode?: 'icon';
}

const DropDownMenu = ({
  items,
  mode,
}: DropDownMenuProps) => {
  const menuItems: MenuProps['items'] = items
    .filter(item => !item.hidden)
    .sort((a, b) => (a.position || 0) - (b.position || 0))
    .map(item => ({
      danger: item.danger,
      disabled: item.disabled,
      icon: item.icon,
      key: item.key,
      label: item.label,
      onClick: item.onClick,
    }));

  return (
    <Dropdown
      menu={{
        items: menuItems,
      }}
      trigger={['click']}
    >
      <Button
        htmlType="button"
        icon={mode === MODE_ICON && <MenuOutlined />}
        style={{
          alignItems: 'center',
          display: 'flex',
          gap: '8px',
        }}
      >
        {mode !== MODE_ICON && <FormattedMessageWrapper id="Actions" />}
        <DownOutlined />
      </Button>
    </Dropdown>
  );

}

export default DropDownMenu;